import React, { useState } from 'react';

import { useCompany } from 'modules/app/hooks/useCompany';
import { SupplierEditor } from 'modules/invoices/components/Invoices/_shared/SupplierEditor';
import {
  type ApiSupplier,
  type Supplier,
} from 'modules/invoices/components/Invoices/_shared/SupplierEditor/supplier';
import { SupplierPersistenceManager } from 'src/core/modules/suppliers/components/SupplierPersistenceManager/SupplierPersistenceManager';

type Props = {
  supplier: ApiSupplier;
  onUpdateSupplierSuccess?(supplier: ApiSupplier): void;
  onCreateSupplierSuccess?(supplier: ApiSupplier): void;
};

export const ToReviewPanelSupplier = ({
  supplier,
  onUpdateSupplierSuccess,
  onCreateSupplierSuccess,
}: Props) => {
  const company = useCompany();
  const [bankProofFile, setBankProofFile] = useState<
    Supplier['details']['bankProofFile'] | undefined
  >(undefined);

  return (
    <SupplierPersistenceManager
      supplier={supplier}
      onUpdateSupplierSuccess={onUpdateSupplierSuccess}
      onCreateSupplierSuccess={onCreateSupplierSuccess}
      shouldTrackSave
      renderSupplierEditor={({ onSave, onTrackSupplierSave }) => (
        <SupplierEditor
          warnForUnsavedChanges
          company={company}
          supplier={supplier}
          onSave={onSave}
          onTrackSupplierSave={onTrackSupplierSave}
          isBankProofFileDisplayed={!!bankProofFile}
          onShowBankProofFile={(file) => setBankProofFile(file || null)}
          onHideBankProofFile={() => setBankProofFile(undefined)}
          showBankProofFileInline={!!bankProofFile}
        />
      )}
    />
  );
};
